module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 512 512",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }